import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { CheckboxListComponent } from "src/app/shared/components/ui/checkbox-list.component";
import { LoaderComponent } from "src/app/shared/components/ui/loader/loader.component";
import { ModalPopupComponent } from "src/app/shared/components/ui/modal-popup.component";
import { RXForm, RXNote } from "src/app/shared/models/order.model";
import { rxPresetNotes } from "src/app/shared/ngrx/ngrx-selectors";
import { DataService } from "src/app/shared/services/data.service";
import { SharedService } from "src/app/shared/services/shared.service";

@Component({
  selector: "select-fixed-note",
  templateUrl: "./select-fixed-note.component.html",
  styleUrls: ["./select-fixed-note.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [
    ModalPopupComponent,
    CommonModule,
    LoaderComponent,
    CheckboxListComponent,
  ],
  standalone: true,
})
export class SelectFixedNoteComponent {
  @Output() onClose = new EventEmitter<RXNote[]>();
  @Input() preselectedNotes: RXNote[] = [];
  @Input() formId: number;
  @Input() profileId: number;

  loading: boolean;
  selectedNotes: RXNote[] = [];

  get notes(): RXNote[] {
    return this.store.selectSignal(rxPresetNotes)();
  }

  constructor(
    private readonly store: Store,
    private sharedService: SharedService,
    private dataService: DataService
  ) {}

  ngAfterViewInit() {
    this.getData();
  }

  getData() {
    this.loading = true;
    this.dataService.getRXPresetNotes(this.formId, this.profileId).subscribe(
      (data) => {
        this.loading = false;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  selectNotes() {
    this.onClose.emit(this.selectedNotes);
  }

  rowPreselectedTest = (row: RXNote): boolean => {
    let find = this.preselectedNotes?.find(
      (n) => n.presetNoteId == row.presetNoteId
    );
    return find != null;
  };
}
